import { underscore } from '@ember/string';

import RegisterPartnerJsSerializer from './-json-api';
export default class RegisterRedirectionTokenSerializer extends RegisterPartnerJsSerializer {
  modelNameFromPayloadKey() {
    return 'register-redirection-token';
  }

  payloadKeyFromModelName() {
    return 'redirection-tokens';
  }

  keyForRelationship(key) {
    return underscore(key);
  }
}
